import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
    { name: 'Team A', value: 220 },
    { name: 'Team B', value: 175 },
    { name: 'Team C', value: 130 },
    { name: 'Team D', value: 75 },
];

const TriagingDashboardChart = () => {
    return (
        <div className="h-full flex flex-col items-center w-full">
            <h2 className="text-xl font-bold text-gray-900 mb-6">Triaging Dashboard</h2>
            <div className="w-full h-full">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 30,
                        }}
                        barSize={60}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={true} horizontal={true} stroke="#E5E7EB" />
                        <XAxis
                            dataKey="name"
                            tick={{ fontSize: 12, fill: '#374151' }}
                            axisLine={true}
                            tickLine={false}
                            dy={10}
                            label={{ value: 'Team', position: 'insideBottom', offset: -20, fontSize: 13, fontWeight: 500 }}
                        />
                        <YAxis
                            tick={{ fontSize: 12, fill: '#374151' }}
                            axisLine={false}
                            tickLine={false}
                            label={{
                                value: 'Number FNOLs',
                                angle: -90,
                                position: 'insideLeft',
                                style: { textAnchor: 'middle', fontSize: '13px', fontWeight: 500 },
                                dx: -15
                            }}
                        />
                        <Tooltip cursor={{ fill: 'transparent' }} />
                        <Bar dataKey="value" fill="#93C5FD" radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default TriagingDashboardChart;
